<!--
 * @Description: 页签栏（白色顶栏上的胶囊页签，2026-11 改版）
 * @FilePath: /sunpay-web/src/components/layout/VisitedViews.vue
-->
<template>
  <div class="views-box">
    <div class="views-list">
      <div v-for="(item, index) in views" :key="viewKey(item)" @click="goto(item)" :class="['view-item', isActive(item) ? 'view-item-active' : '']">
        {{ item.name }}
        <template v-if="item.query && item.label">{{ item.query[item.label] }}</template>
        <el-icon v-if="views.length > 1" class="view-close" @click.stop="removeViews(item, index)"><Close />
      </el-icon>
      </div>
    </div>
  </div>
</template>
<script setup>
import { Close } from '@element-plus/icons-vue';
import { computed, inject } from 'vue';
import { useRouter, useRoute } from 'vue-router';
const $store = inject('$store')
const router = useRouter()
const route = useRoute()
const views = computed(() => $store?.state?.visitedMenu || [])
const viewKey = (item) => {
  if (item?.query && item?.label) {
    return `${item.path}?${item.label}=${item.query[item.label]}`
  }
  return item.path
}
const isActive = (item) => {
  if (route.path !== item.path) return false
  if (item?.query && item?.label) {
    return route.query?.[item.label] == item.query?.[item.label]
  }
  return true
}
const goto = (item) => {
  if (item.query) {
    router.push({
      path: item.path,
      query: item.query
    })
  } else {
    router.push({
      path: item.path
    })
  }
}

const removeViews = (item, index) => {
  const fullPath = router.resolve({ path: item.path, query: item.query }).fullPath
  $store.commit("BUMP_VIEW_CACHE_VERSION", fullPath)
  if (isActive(item)) {
    const list = views.value || []
    const fallback = index > 0 ? list[index - 1] : list[index + 1]
    if (fallback?.query) {
      router.push({
        path: fallback.path,
        query: fallback.query
      })
    } else if (fallback?.path) {
      router.push({
        path: fallback.path,
      })
    } else {
      const first = $store.state.firstMenuPath
      router.push({ path: first?.path || '/dashboard' })
    }
  }
  $store.commit("DEL_VISITEDMENU", item);
}
</script>
<style lang="less" scoped>
  .views-box {
    flex: 1;
    min-width: 0;
    height: @header-height;
    display: flex;
    align-items: center;
  }
  .views-list {
    display: flex;
    align-items: center;
    gap: 4px;
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      height: 0;
    }
  }
  .view-item {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 28px;
    padding: 0 10px;
    border-radius: @radius-s;
    color: @text-secondary;
    font-size: 12px;
    white-space: nowrap;
    cursor: pointer;
    flex: 0 0 auto;
    &:hover {
      background: @bg-page;
      color: @text-primary;
    }
    .view-close {
      width: 14px;
      height: 14px;
      border-radius: 50%;
      color: inherit;
      opacity: .7;
      &:hover {
        background: rgba(47, 107, 255, .16);
        opacity: 1;
      }
    }
    &-active {
      background: @primary-light;
      color: @primary;
      font-weight: 500;
      &:hover {
        background: @primary-light;
        color: @primary;
      }
    }
  }
</style>
